import React from "react";
import { ErrorMessage } from "@hookform/error-message";
import { Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Box from "@material-ui/core/Box";

interface ErrorProps {
  name: string;
  customError?: boolean;
  errors?: any;
  nameLang?: string;
  maxLength?: number;
  minLength?: number;
  patternMessage?: string;
}
const ErrorComponent = (props: ErrorProps) => {
  const {
    customError,
    errors,
    name,
    minLength,
    maxLength,
    patternMessage,
  } = props;
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  return !customError ? (
    <ErrorMessage
      errors={errors}
      name={name}
      render={() => (
        <Typography component={"span"}>
          <Box color={"red"} fontSize={theme.spacing(1)}>
            {errors[name]?.type === "maxLength"
              ? //? maxLength + " you rechied the max number"
                t("max_length")
              : errors[name]?.type === "minLength"
              ? //? "the minimum length is " + minLength
                t("min_length")
              : errors[name]?.type === "required"
              ? t("field_required")
              : errors[name]?.type === "pattern"
              ? patternMessage
              : ""}
          </Box>
        </Typography>
      )}
    />
  ) : (
    <Typography component={"span"}>
      <Box color={"red"} fontSize={theme.spacing(1)}>
        {patternMessage}
      </Box>
    </Typography>
  );
};
export { ErrorComponent };
